type EvaluationPathArgs = {
  courseId: string;
  evaluationTemplateId: string;
  scenarioId: string;
};

interface EvaluationAttemptPathArgs extends EvaluationPathArgs {
  evaluationId: string;
}

export function getEvaluationParticipantAttemptPath({
  courseId,
  evaluationId,
  evaluationTemplateId,
  scenarioId,
}: EvaluationAttemptPathArgs) {
  return `/participant/sessions/${courseId}/assessments/${evaluationId}/result?evaluationTemplateId=${evaluationTemplateId}&scenarioId=${scenarioId}`;
}

export function getEvaluationAttemptPath({
  courseId,
  evaluationId,
  evaluationTemplateId,
  scenarioId,
}: EvaluationAttemptPathArgs) {
  return `/sessions/${courseId}/assessments/${evaluationId}?evaluationTemplateId=${evaluationTemplateId}&scenarioId=${scenarioId}`;
}

type EvaluationOverviewPathArgs = Omit<EvaluationPathArgs, 'scenarioId'> & {
  scenarioId?: string;
};

export function getEvaluationOverviewPath({
  courseId,
  evaluationTemplateId,
  scenarioId,
}: EvaluationOverviewPathArgs) {
  return scenarioId
    ? `/sessions/${courseId}/assessments/scenario/${scenarioId}/${evaluationTemplateId}`
    : `/sessions/${courseId}/assessments/evaluation/${evaluationTemplateId}`;
}

interface EvaluationParticipantPathArgs extends EvaluationPathArgs {
  participantId: string;
}

export function getEvaluateParticipantPath({
  courseId,
  evaluationTemplateId,
  participantId,
  scenarioId,
}: EvaluationParticipantPathArgs) {
  const evaluationOverviewPath = getEvaluationOverviewPath({
    courseId,
    evaluationTemplateId,
    scenarioId,
  });
  return `${evaluationOverviewPath}/evaluate/${participantId}`;
}

export function getSessionParticipantsPath(courseId: string) {
  return `/sessions/${courseId}/attendance`;
}
